import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import { withOffset, selectors } from '../../Stream';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { fetchNext } from './actionCreators';
import { requestPuppy } from '@wix/da-http-client';
function* handleFetchNext(action) {
    const { streamId } = action.payload;
    const { offset, limit, streamParams } = yield select((state)=>({
            streamParams: selectors.getStreamParams(state, streamId),
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    const params = {
        deviationid: streamParams.deviationId,
        type: 'favourite',
        offset,
        limit,
        expand: 'user.profile'
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'who',
        params
    }, undefined, 'dadeviation');
    if (result) {
        const { total, hasMore, nextOffset, results } = result;
        yield all([
            ...(results !== null && results !== void 0 ? results : []).map((user)=>{
                var _user_isWatching;
                return put(setWatchingState(user.username, (_user_isWatching = user.isWatching) !== null && _user_isWatching !== void 0 ? _user_isWatching : false));
            }),
            put(withOffset.actions.fetchSuccessDeduped({
                streamId,
                hasMore: !!hasMore,
                nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                items: results,
                total
            }))
        ]);
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(fetchNext, handleFetchNext)
    ]);
}

//# sourceMappingURL=saga.js.map